import { render, staticRenderFns } from "./commonTips.vue?vue&type=template&id=1733c926&scoped=true"
import script from "./commonTips.vue?vue&type=script&lang=js"
export * from "./commonTips.vue?vue&type=script&lang=js"
import style0 from "./commonTips.vue?vue&type=style&index=0&id=1733c926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1733c926",
  null
  
)

export default component.exports